<template>
  <div class="log-list">
    <a-row :gutter="8">
      <a-col :span="6">
        <div class="right-select">
          <span class="filter-selection">权益类型</span>
          <a-select
            placeholder="权益类型"
            style="width: calc(100% - 68px);margin-left: 8px;"
            v-model="jurisdiction"
          >
            <a-select-option
              :value="item.id"
              v-for="item in cardTypes"
              :key="item.id"
            >
              {{ item.desc3 }}
            </a-select-option>
          </a-select>
        </div>
      </a-col>
      <a-col :span="6">
        <a-button type="primary" @click="search" style="margin-right: 8px;">
          搜索
        </a-button>
        <a-button @click="reset" class="ant-btn-secondary">
          重置
        </a-button>
      </a-col>
    </a-row>
    <div class="table-wrap">
      <a-table
        class="table"
        row-key="id"
        :scroll="scroll"
        :loading="tableLoading"
        :columns="columns"
        :data-source="logList"
        :pagination="false"
        @change="handleTableChange"
      >
        <template slot="expireNumberSoon" slot-scope="text, record">
          <span v-if="record.cardType !== 18" :style="{color: record.expireNumberSoon > 0 ? '#FF5C5C' : 'none'}">{{ record.expireNumberSoon }}</span>
          <span v-else>--</span>
        </template>
      </a-table>
    </div>
    <div class="pagination">
      <a-pagination
        v-show="pagination.total > 0"
        v-model="pagination.current"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @change="handleChangePageNum"
      />
    </div>
  </div>
</template>

<script>
import { columns } from './columns'
import { mapGetters } from 'vuex'

export default {
  name: 'LogList',
  data() {
    return {
      scroll: { x: 1280, y: 'calc(100vh - 300px)' },
      columns,
      logList: [],
      cardTypes: [
        {
          name: '全部',
          id: -1
        }
      ],
      jurisdiction: -1,
      tableLoading: false,
      sorter: undefined, // // "descend": 降序，"ascend": 升序， undefined: 不排序
      pagination: {
        pageSize: 20,
        total: 0,
        current: 1
      }
    }
  },

  mounted() {
    this.initCardType()
    this.getList()
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    })
  },

  methods: {
    initCardType() {
      this.$service.studentRight.xkhCardType().then(res => {
        this.cardTypes = [
          {
            desc3: '全部',
            id: -1
          },
          ...res
        ]
      })
    },
    handleTableChange (pag, filters, sorter) {
      this.sorter = sorter.order // sorter.order: "descend": 降序，"ascend": 升序， undefined: 不排序
      this.getList()
    },

    // 获取学员列表
    async getList() {
      this.tableLoading = true
      const searchParams = {
        insId: this.userInfo.institutionId,
        cardTypes: [this.jurisdiction >= 0 ? this.jurisdiction : -1],
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        expireTimeSort: !this.sorter ? undefined : this.sorter === 'ascend' ? 'ASC' : 'DESC'
      }

      if (this.jurisdiction === -1) delete searchParams.cardTypes // 不传查全部
      if (!this.sorter) delete searchParams.expireTimeSort // 不传查全部

      this.$service.studentRight.getLogList(searchParams).then(res => {
        this.tableLoading = false
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        this.logList = res.list || []
      }).finally(() => {
        this.tableLoading = false
      })
    },

    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },

    search() {
      this.pagination.current = 1
      this.getList()
    },

    reset() {
      this.jurisdiction = -1
      this.pagination.current = 1
      this.getList()
    }
  }
}
</script>

<style scoped lang="less">
.log-list {
  height: 100%;
  padding: 24px;
  overflow: hidden;
  background: #fff;
  .table-wrap {
    margin-top: 24px;
  }
  .pagination {
    height: 30px;
    text-align: right;
    padding-top: 12px;
  }
}
</style>
<style>
.ant-page-header-ghost {
  padding: 0;
}
</style>
